import Header from '../../components/header/Header';
import UserWalletInfo from '../../features/user-profile/components/UserWalletInfo';
import UserAvatar from '../../features/avatar/Avatar';
import useGetUserTier from '../../services/user/queries/useGetUserTier';
import TierAvatarProgress from '../../features/avatar/TierAvatarProgress';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import UserControls from '@/features/user-profile/components/UserControls';

const MyHub = () => {
  const user = useSelector((state: ReducerState) => state.auth);

  const { isSuccess, data } = useGetUserTier({
    userId: user.id,
  });

  if (!user.id || !isSuccess || !data) {
    return null;
  }

  const userTier = data.data;

  return (
    <div className="text-[16px]">
      <Header showGoBackButton />
      <div className="flex flex-col gap-4">
        <div className="mt-6 flex items-center gap-8 px-7">
          <TierAvatarProgress
            className="h-[100px] w-[100px]"
            small
            progressPercentage={userTier.tierProgressPercentage}
          >
            <UserAvatar userId={user.id} className="h-[84px] w-[84px]" />
          </TierAvatarProgress>
          <h2 className="font-manrope text-xl font-bold text-ph-gray-white">{user.alias}</h2>
        </div>
        <UserControls />
        <UserWalletInfo />
      </div>
    </div>
  );
};

export default MyHub;
